(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oneless-situation-catalog"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.situationsInit === 'true') return;
    if (sectionEl.classList.contains('ol-situations--continuation')) return;
    sectionEl.dataset.situationsInit = 'true';

    const searchInput = sectionEl.querySelector('.ol-situations__search-input');
    const categorySelect = sectionEl.querySelector('.ol-situations__category-select');
    const resetBtn = sectionEl.querySelector('.ol-situations__filter-reset');
    const emptyResetBtn = sectionEl.querySelector('.ol-situations__empty-reset');
    const emptyState = sectionEl.querySelector('.ol-situations__empty-results');
    const liveRegion = sectionEl.querySelector('.ol-situations__filter-status');
    const seeAllWrap = sectionEl.querySelector('.ol-situations__see-all');
    const seeAllBtn = sectionEl.querySelector('.ol-situations__see-all-button');
    const grid = sectionEl.querySelector('.ol-situations__grid');
    // A section holds at most 50 blocks; later situations live in continuation sections and join this grid.
    if (grid) {
      document.querySelectorAll('.ol-situations--continuation').forEach(function(extra) {
        extra.querySelectorAll('.ol-situations__card').forEach(function(card) { grid.appendChild(card); });
        if (!extra.querySelector('.ol-situations__editor')) extra.hidden = true;
      });
    }
    const cards = Array.from(sectionEl.querySelectorAll('.ol-situations__card'));
    if (grid) grid.classList.remove('ol-situations__grid--featured');

    const featured = cards.filter(function(card) { return card.hasAttribute('data-featured'); });
    featured.sort(function(a, b) { return Number(b.getAttribute('data-featured')) - Number(a.getAttribute('data-featured')); });
    if (grid) featured.forEach(function(card) { grid.insertBefore(card, grid.firstChild); });

    if (!searchInput && !categorySelect) return;
    sectionEl.querySelector('.ol-situations__toolbar').hidden = false;

    const chipRow = sectionEl.querySelector('.ol-situations__theme-chips');
    const FEATURED = '__featured';
    const FIRST_BUTTONS = 8;
    const homeView = featured.length ? FEATURED : '';
    let view = homeView;

    // The theme filter comes from the cards, so a new theme appears by itself and fills a button by its card count.
    const themes = {};
    cards.forEach(function(card) {
      const value = card.getAttribute('data-category');
      if (!value) return;
      if (!themes[value]) themes[value] = { value: value, label: card.getAttribute('data-theme-label'), count: 0 };
      themes[value].count++;
    });
    const ranked = Object.keys(themes).map(function(value) { return themes[value]; }).sort(function(a, b) {
      return b.count - a.count || a.label.localeCompare(b.label);
    });

    const chips = [];
    function addChip(value, text) {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'ol-situations__theme-chip';
      chip.textContent = text;
      chip.addEventListener('click', function() {
        view = value;
        applyFilter();
      });
      chipRow.appendChild(chip);
      chips.push({ el: chip, value: value });
    }
    if (featured.length) addChip(FEATURED, 'Featured');
    addChip('', 'All (' + cards.length + ')');
    ranked.slice(0, FIRST_BUTTONS).forEach(function(theme) { addChip(theme.value, theme.label + ' (' + theme.count + ')'); });

    const more = ranked.slice(FIRST_BUTTONS);
    if (more.length) {
      categorySelect.add(new Option('More themes', ''));
      more.forEach(function(theme) { categorySelect.add(new Option(theme.label + ' (' + theme.count + ')', theme.value)); });
      categorySelect.hidden = false;
    }
    if (seeAllBtn) seeAllBtn.textContent = 'See all ' + cards.length + ' situations';

    function applyFilter() {
      const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      const shown = view === FEATURED && query ? '' : view;
      let matchCount = 0;

      cards.forEach(function(card) {
        const title = card.getAttribute('data-title') || '';
        const desc = card.getAttribute('data-description') || '';
        const cat = card.getAttribute('data-category') || '';

        const matchView = !shown || (shown === FEATURED ? card.hasAttribute('data-featured') : cat === shown);
        const matchQuery = !query || title.indexOf(query) !== -1 || desc.indexOf(query) !== -1;
        const visible = matchView && matchQuery;

        if (visible) {
          card.removeAttribute('hidden');
          matchCount++;
        } else {
          card.setAttribute('hidden', '');
        }
      });

      chips.forEach(function(chip) { chip.el.setAttribute('aria-pressed', chip.value === view ? 'true' : 'false'); });
      const inMore = more.some(function(theme) { return theme.value === view; });
      categorySelect.value = inMore ? view : '';
      categorySelect.classList.toggle('is-active', inMore);

      if (seeAllWrap) seeAllWrap.hidden = shown !== FEATURED;

      if (emptyState) {
        if (matchCount === 0) {
          emptyState.removeAttribute('hidden');
          if (grid) grid.setAttribute('data-empty', 'true');
        } else {
          emptyState.setAttribute('hidden', '');
          if (grid) grid.removeAttribute('data-empty');
        }
      }

      const hasFilters = Boolean(query || view !== homeView);
      if (resetBtn) {
        if (hasFilters) {
          resetBtn.removeAttribute('hidden');
        } else {
          resetBtn.setAttribute('hidden', '');
        }
      }

      if (liveRegion) {
        if (matchCount === 0) {
          liveRegion.textContent = 'No situations found.';
        } else if (matchCount === 1) {
          liveRegion.textContent = '1 situation found.';
        } else {
          liveRegion.textContent = matchCount + ' situations found.';
        }
      }
    }

    function showView(next) {
      if (searchInput) searchInput.value = '';
      view = next;
      applyFilter();
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilter);
    }
    categorySelect.addEventListener('change', function() {
      view = categorySelect.value;
      applyFilter();
    });
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        showView(homeView);
        if (searchInput) searchInput.focus();
      });
    }
    if (emptyResetBtn) {
      emptyResetBtn.addEventListener('click', function() { showView(''); });
    }
    if (seeAllBtn) {
      seeAllBtn.addEventListener('click', function() { showView(''); });
    }

    applyFilter();
  }

  function initAll() {
    const sections = document.querySelectorAll('.ol-situations');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    const container = e.target.classList && e.target.classList.contains('ol-situations')
      ? e.target
      : (e.target.querySelector ? e.target.querySelector('.ol-situations') : null);
    if (container) {
      initSection(container);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oneless-situation-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oneless-situation-guide')) {
  customElements.define('oneless-situation-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('[data-guide-form]');
      const result = this.querySelector('[data-guide-result]');
      const offer = this.querySelector('[data-result-offer]');
      if (!form || !result) return;
      form.addEventListener('change', () => { result.hidden = true; if (offer) offer.hidden = true; });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const answers = Object.fromEntries(new FormData(form));
        let title, body, recommend = false;
        if (answers.owned === 'works') {
          title = 'Keep the setup that already works.';
          body = 'You already have a suitable potting surface. There is no need to buy another mat for the same job. Leave this one out.';
        } else if (answers.problem === 'water') {
          title = 'A potting mat is not the right fix.';
          body = 'This mat is for temporary repotting work, not for catching drainage water under a plant every day. Check the pot and a properly sized plant saucer instead.';
        } else if (answers.problem === 'large') {
          title = 'Make more room before adding a mat.';
          body = 'This compact mat is not intended for large floor plants. Plan a work area large enough for the plant, pot and loose soil; do not squeeze the job into this size.';
        } else if (answers.space !== 'yes') {
          title = answers.space === 'no' ? 'This size does not fit your surface.' : 'Measure first. Decide after.';
          body = 'The mat is listed as 60 × 40 cm (about 24 × 16 in). Allow extra room for your plant, pot and tools. Check the dimensions before buying.';
        } else if (answers.problem === 'soil' && ['none','spills'].includes(answers.owned)) {
          title = 'A dedicated potting surface may help.';
          body = 'Your situation matches the job this mat is intended for: loose soil from repotting a small plant, with room to work. Check the dimensions and see whether it improves on anything you already own.';
          recommend = true;
        } else {
          title = 'Check your answers before choosing.';
          body = 'Choose an answer to each question so we can suggest an appropriate next step.';
        }
        this.querySelector('[data-result-title]').textContent = title;
        this.querySelector('[data-result-body]').textContent = body;
        if (offer) offer.hidden = !recommend;
        result.dataset.recommend = String(recommend);
        result.hidden = false;
        result.focus({preventScroll:true});
        result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
